export const events = {
    'third.created': 'company',
    'third.updated': 'company',
    'third.deleted': 'company',
    'annotation.created': 'comment',
    'annotation.updated': 'comment',
    'annotation.deleted': 'comment',
    'annotation.replied': 'comment',
    'third.address.created': 'address',
    'third.address.updated': 'address',
    'third.address.deleted': 'address',
    'opportunity.created': 'opportunity',
    'opportunity.updated': 'opportunity',
    'opportunity.deleted': 'opportunity',
    'opportunity.doc.linked': 'document',
    'opportunity.maindoc.updated': 'document',
    'opportunity.marketingautomation.sended': 'sent-email',
    'opportunity.owner.updated': 'logo',
    'opportunity.staff.assigned': 'logo',
    'opportunity.status.updated': 'opportunity',
    'opportunity.step.updated': 'opportunity',
    'opportunity.third.updated': 'company',
    'thirdcontact.created': 'contact',
    'thirdcontact.deleted': 'contact',
    'thirdcontact.updated': 'contact',
    'third.deliveryaddress.updated': 'address',
    'third.mainaddress.updated': 'address',
    'third.maincontact.updated': 'contact',
    'third.billingcontact.updated': 'contact',
    'third.owner.updated': 'logo',
    'third.prefs.updated': 'company',
    'third.transformed': 'company',
    'event.created': 'calendar',
    'event.deleted': 'calendar',
    'event.updated': 'calendar',
    'task.created': 'task',
    'task.deleted': 'task',
    'task.updated': 'task',
    'task.completed': 'task',
    'task.uncompleted': 'task',
    'task.label.updated': 'task',
    'task.date.updated': 'task',
    'task.staff.updated': 'logo',
    'task.owner.updated': 'logo',
    'people.created': 'contact',
    'people.updated': 'contact',
    'people.deleted': 'contact',
    'people.deliveryaddress.updated': 'address',
    'people.mainaddress.updated': 'address',
    'people.address.updated': 'address',
    'people.address.created': 'address',
    'people.address.deleted': 'address',
    'people.owner.updated': 'logo',
    'email.sent': 'sent-email',
    'email.link.sent': 'sent-email',
    'email.failed': 'sent-email',
    'email.received': 'inbox-email',
    'email.scheduled.created': 'sent-email',
    'email.scheduled.deleted': 'sent-email',
    'email.scheduled.sent': 'sent-email',
    'email.opportunity.marketingautomation.sent': 'sent-email',
    'email.dunning': 'sent-email',
    'email.toggleread': 'email',
    'email.unlinked': 'email',
    'email.linked': 'email',
    'email.restored': 'email',
    'email.deleted': 'email',
    'phonecall.created': 'phone',
    'phonecall.deleted': 'phone',
    'phonecall.updated': 'phone',
    'propdocument.deleted': 'document',
    'propdocument.email.sent': 'sent-email',
    'propdocument.user.viewed': 'tracking',
    'propdocument.user.downloaded': 'tracking',
    'propdocument.anonymous.viewed': 'tracking',
    'propdocument.anonymous.downloaded': 'tracking',
    'proptemplate.created': 'document',
    'proptemplate.updated': 'document',
    'proptemplate.deleted': 'document',
    'timetracking.created': 'tracking',
    'timetracking.updated': 'tracking',
    'timetracking.deleted': 'tracking',
    'email.link.clicked': 'tracking',
    'email.thread.replied': 'email',
    'email.link.replied': 'email',
    'email.link.restored': 'email',
    'email.link.deleted': 'email',
    'email.link.linked': 'email',
    'email.link.unlinked': 'email',
    'ticket.created': 'support',
    'ticket.assigned': 'support',
    'ticket.step.updated': 'support',
    'ticket.updated': 'support',
    'ticket.deleted': 'support',
    'email.opened': 'email',
    'email.dropped': 'email',
    'email.bounced': 'email',
    'email.delivered': 'sent-email',
    'third.sharing.updated': 'company',
    'opportunity.sharing.updated': 'opportunity',
    'doc.sharing.updated': 'document',
    'people.sharing.updated': 'contact',
    'snippettracking.created': 'tracking',
    'third.batch.created': 'company',
    'third.address.batch.created': 'address',
    'people.batch.created': 'contact',
    'people.address.batch.created': 'address',
    'opportunity.batch.deleted': 'opportunity',
    'third.batch.updated': 'company',
    'third.address.batch.updated': 'address',
    'people.batch.updated': 'contact',
    'people.batch.deleted': 'contact',
    'people.address.batch.updated': 'address',
    'third.batch.deleted': 'company',
    'doc.condition.acceptation': 'document',
    'staff.created': 'logo',
    'staff.updated': 'logo',
    'staff.deleted': 'logo',
    'propdocument.created': 'document',
    'propdocument.updated': 'document',
    'propdocument.step.updated': 'document',
    'marketing.email.clicked': 'marketing',
    'marketing.email.opened': 'marketing',
    'marketing.email.received': 'marketing',
    'marketing.form.opened': 'marketing',
    'marketing.form.submitted': 'marketing',
    'marketing.page.clicked': 'marketing',
    'marketing.page.opened': 'marketing',
    'marketing.sms.answered': 'marketing',
    'marketing.sms.clicked': 'marketing',
    'marketing.sms.sent': 'marketing',
    'marketing.survey.opened': 'marketing',
    'marketing.survey.submitted': 'marketing',
    'marketing.transactional-email.clicked': 'marketing',
    'marketing.transactional-email.opened': 'marketing',
    'marketing.transactional-email.received': 'marketing',
    'marketing.transactional-email.sent': 'marketing',
    'third.authorization.accepted': 'consent',
    'third.authorization.send': 'consent',
};
